module.exports = __webpack_public_path__ + "img/weixinerweima.1c3d803c.png";